import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOpenItemSelection extends Layout {
    sourceOpenItem: DataSource;
    tableOpenItems: Table;
}
